<div class="box-border w-full text-base">
  @let hasError = ngControl.errors && ngControl.touched;
  <div
    (click)="toggle()"
    class="flex cursor-pointer items-center rounded-sm"
    [ngClass]="{
      'cursor-not-allowed!': ngControl.control!.disabled,
    }">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      type="checkbox"
      [id]="id()"
      [formControl]="ngControl.control! | toFormControl"
      class="pointer-events-none sr-only h-5 w-5" />
    <div
      class="border-input-ring flex h-6 w-6 items-center justify-center rounded-sm border"
      [ngClass]="{
        'bg-transparent': !ngControl.value,
        'bg-input-focus': ngControl.value && !ngControl.disabled,
        'bg-standard-text-disabled': ngControl.value && ngControl.disabled,
        'border-input-focus border-2':
          !hasError && !ngControl.control!.disabled && !ngControl.value,
        'cursor-not-allowed!': ngControl.control!.disabled,
        'text-input-error! border-input-error!': hasError,
      }"
      [ngStyle]="{
        color: inputSelectedColor(),
        background: ngControl.value ? inputSelectedColor() : '',
        borderRadius: borderRounding(),
        borderColor: !ngControl.value
          ? borderAndLabelColor()
          : inputSelectedColor(),
      }">
      <span
        class="material-symbols-rounded pt-0.5"
        [style.visibility]="ngControl.value ? 'visible' : 'hidden'"
        [ngStyle]="{
          color: ngControl.control!.disabled ? '#FFF' : inputContrastColor(),
        }">
        check
      </span>
    </div>

    @if (formattedLabel()) {
      <label
        [attr.data-testid]="id() | appendTestId: 'label'"
        [for]="id()"
        [ngClass]="{
          'cursor-not-allowed!': ngControl.control!.disabled,
        }"
        [ngStyle]="{
          color: corporateDesignService.isDarkModeActive()
            ? corporateDesignService.corporateDesign().colorAdmixtures
                .dark_text_high
            : '',
        }"
        class="pointer-events-none flex w-full cursor-pointer gap-2 pl-3 text-base">
        {{ formattedLabel() }}
      </label>
    }
  </div>
  @if (hasError) {
    <aw-error-message
      [attr.data-testid]="id() | appendTestId: 'error'"
      [style.visibility]="hasError && !errorTemplate() ? 'visible' : 'hidden'">
      <ng-content></ng-content>
    </aw-error-message>
    <aw-error-message
      [attr.data-testid]="id() | appendTestId: 'error'"
      [style.visibility]="
        hasError && errorTemplate() ? 'visibility' : 'hidden'
      ">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
